// Copyright (c) 2021, Elicenciamento. All rights reserved.

import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { SnackbarProvider } from "./contexts/snackbar";
import { LoadingProvider } from "./contexts/loading";
import { DebtsProvider } from "./routes/Licensing/contexts/Debts";
import ApplicationLoading from "./components/ApplicationLoading";

const Licensing = lazy(() => import("./routes/Licensing"));
const LicensingCheck = lazy(() => import("./routes/LicensingCheck"));
const Order = lazy(() => import("./routes/Order"));
const Home = lazy(() => import("./routes/Home"));

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Suspense fallback={<ApplicationLoading />}>
        <LoadingProvider>
          <SnackbarProvider>
            <DebtsProvider>
              <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/consultas" component={LicensingCheck} />
                <Route path="/consulta/:document" component={Licensing} />
                <Route path="/pedido/:id" component={Order} />
              </Switch>
            </DebtsProvider>
          </SnackbarProvider>
        </LoadingProvider>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
